/**
 * Increase Contrast overrides (KAN-304, enterprise Tier B). Extra CSS variable values appended by
 * `buildThemeCss` inside `@media (prefers-contrast: more)`, AFTER the base Light/Graphite blocks so they win.
 * Names are the palette's own `--cvx-<group>-<key>` vars. Kept out of themePalettes*.js on purpose.
 */

export const CONTRAST_LIGHT = {
  '--cvx-border-subtle': '#cbd5e1',
  '--cvx-border-default': '#cbd5e1',
  '--cvx-border-field': '#94a3b8',
  '--cvx-fg-muted': '#475569',
  '--cvx-fg-secondary': '#334155',
};

export const CONTRAST_DARK = {
  '--cvx-border-subtle': '#545458',
  '--cvx-border-default': '#545458',
  '--cvx-border-field': '#8E8E93',
  '--cvx-fg-muted': '#AEAEB2',
  '--cvx-fg-secondary': '#D1D1D6',
};

const decl = (o) => Object.entries(o).map(([k, v]) => `${k}:${v};`).join('');

/** The media block; must be appended after the base blocks. */
export function buildContrastCss(light = CONTRAST_LIGHT, dark = CONTRAST_DARK) {
  return `@media (prefers-contrast: more){:root{${decl(light)}}:root[data-theme="dark"]{${decl(dark)}}}\n`;
}
